import { z } from 'zod'
import { EndDate, Id, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace OperationType {
  export interface Data {
    /** @description Status identifier (key) */
    readonly id: number

    /** @description Name */
    readonly name: string

    /** @description Short name */
    readonly shortName?: string

    /** @description Description */
    readonly description?: string

    /** @description Record entry (update) date */
    readonly updateDate: Date

    /** @description Record validity start */
    readonly startDate: Date

    /** @description Record validity end */
    readonly endDate: Date

    /** @description Activity status */
    readonly isActive: boolean
  }
}

/** @description Information on operation type */
export class OperationType extends GarItem<
  'OperationType',
  OperationType.Data
> {
  static readonly SCHEMA: GarItem.Schema<OperationType.Data> = z
    .strictObject({
      ID: Id,

      NAME: z.string().describe('Name'),

      SHORTNAME: z.string().optional().describe('Short name'),

      DESC: z.string().optional().describe('Description'),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTIVE: IsActive,
    })
    .transform<OperationType.Data>(attributes => ({
      id: attributes.ID,
      name: attributes.NAME,
      shortName: attributes.SHORTNAME,
      description: attributes.DESC,
      updateDate: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'OperationType'

  protected get schema() {
    return OperationType.SCHEMA
  }
}
